import type { ButtonProps } from 'uikit';
import { Button, Tooltip, cnMixCard } from 'uikit';

import cn from 'classnames';
import type React from 'react';
import { useState, useCallback, useRef } from 'react';

import styles from './ButtonAlert.module.css';

interface IButtonAlertProps extends Omit<ButtonProps, 'view'> {
    className?: string;
    style?: React.CSSProperties;
    isOpenTooltip?: boolean;
    textTooltip?: string;
}

export const ButtonAlert = ({
    disabled,
    className,
    style,
    isOpenTooltip,
    textTooltip,
    ...props
}: IButtonAlertProps) => {
    const refBtn = useRef<HTMLButtonElement>(null);

    const [isTooltip, setIsTooltip] = useState<boolean>(false);

    const handleMouseMoveButton = useCallback(() => {
        if (isOpenTooltip) {
            setIsTooltip(true);
        }
    }, [isOpenTooltip]);

    const handleMouseLeaveButton = useCallback(() => {
        if (isOpenTooltip) {
            setIsTooltip(false);
        }
    }, [isOpenTooltip]);

    return (
        <>
            <Button
                className={cn(styles.button, cnMixCard({ status: 'alert' }), className, {
                    [styles.normal]: !disabled,
                    [styles.disabled]: disabled,
                })}
                disabled={disabled}
                view="secondary"
                style={style}
                ref={refBtn}
                onMouseMove={handleMouseMoveButton}
                onMouseLeave={handleMouseLeaveButton}
                {...props}
            />
            {isOpenTooltip && isTooltip && (
                <Tooltip size="s" direction="upCenter" anchorRef={refBtn} isInteractive={false}>
                    {textTooltip}
                </Tooltip>
            )}
        </>
    );
};

ButtonAlert.displayName = 'ButtonAlert';
